export const slides = [
    {
        image: "https://www.operatoday.org/images/Teatro_alla_Scala.jpg",
        title: "THE MOST ICONIC OPERA HOUSES & FESTIVALS",
        text: "",
    },
    {
        image: "https://www.operatoday.org/images/Royal_opera_house.png",
        title: "THE MOST RENOWNED PERFORMERS OF OUR TIME",
        text: "",
    },
    {
        image: "https://www.operatoday.org/images/paris_opera.jpg",
        title: "THE GREATEST COMPOSERS OF ALL TIME",
        text: "",
    },
];
export const mapContainerStyle = {
    height: "400px",
    width: "100%",
};
export const defaultCenter = {
    lat: 45.4642,
    lng: 9.19,
};
export const SelectPriceOrderOptions = [
    { label: "Price Ascending", value: "asc" },
    { label: "Price Decending", value: "decs" },
];
